const colors = {
  black: 'rgb(0, 0, 0)',
  white: 'rgb(255, 255, 255)',
  white50: 'rgba(255, 255, 255, 0.5)',
  gray: 'rgb(204, 204, 204)',
  lighterGray: 'rgb(244, 245, 246)',
  lightGray: 'rgb(230, 230, 230)',
  mediumGray: 'rgb(155, 155, 155)',
  mediumGray2: 'rgb(129, 129, 129)',
  darkGray: 'rgb(51, 51, 51)',
  blue: 'rgb(70, 152, 202)',
  lightBlue: 'rgb(209, 231, 236)',
  darkBlue: 'rgb(113, 134, 140)',
  green: 'rgb(116, 165, 74)',
  lightGreen: 'rgb(232, 236, 226)',
  darkGreen: 'rgb(136,144,129)',
  darkPurple: 'rgb(66,44,64)',
  lightPurple: 'rgb(180, 156, 185)',
  red: 'rgb(200, 49, 69)',
  lighterRed: ' rgb(222, 194, 194)',
  darkRed: ' rgb(95, 39, 39)',
  darkBrown: 'rgb(95,66,64)',
  darkerBrown: 'rgb(71, 64, 64)',
  lightBrown: 'rgb(229,222,217)',
  lightYellow: 'rgb(255, 246, 233)',

  brightOrange: '#e68532',
  brightBlue: '#3b91a4',
  brightYellow: '#ffd700',
  brightGreen: '#7b9f34',
  brightBrown: '#86482c',
};

const breakPoints = {
  xs: 0,
  sm: 600,
  md: 840,
  lg: 1280,
  xl: 1920,
};

const brandColors = {
  primaryColor: '#2e0a2b',
  secondaryColor: '#91775e',
  violet: '#2e0a2b',
  brown: '#ae9379',
  beige: '#eeeddb',
  gray: '#9c9da0',
};

const textColors = {
  bodyText: brandColors.violet,
  mutedText: '#7D7D7D',
  disabledText: '#B9B9B9',
  lightText: colors.white,
};
const textFontFamilies = {
  fontTypography: 'poppins, sans-serif',
  fontBody1: 'poppins, sans-serif',
  fontBody2: 'poppins, sans-serif',
  fontHeadings: 'bely-display, sans-serif',
  fontButton: 'bely-display, sans-serif',
};

const textFontSizesMobile = {
  fontSizeLeadText: '1.125rem',
  fontSizeTypography: '0.938rem',
  fontSizeButton: '0.875rem',
  fontSizeBody1: '0.938rem',
  fontSizeBody2: '0.813rem',
  fontSizeH1: '2rem',
  fontSizeH2: '1.5rem',
  fontSizeH3: '1.188rem',
  fontSizeH4: '1.125rem',
};
const textFontSizesDesktop = {
  fontSizeLeadText: '1.188rem',
  fontSizeTypography: '1rem',
  fontSizeButton: '1rem',
  fontSizeBody1: '1rem',
  fontSizeBody2: '0.813rem',
  fontSizeH1: '2.9rem',
  fontSizeH2: '2rem',
  fontSizeH3: '1.5rem',
  fontSizeH4: '1.125rem',
};
const textFontWeight = {
  typography: 'normal',
  button: 'normal',
  body1: 'normal',
  body2: 'normal',
  h1: 'normal',
  h2: 'normal',
  h3: 'normal',
  h4: 'normal',
};
const textLineHeightsMobile = {
  lineHeightLeadText: '1.5',
  lineHeightQuote: '1.47',
  lineHeightBody1: '1.47',
  lineHeightBody2: '1.54',
  lineHeightHeadings: 'normal',
};

const textLineHeightsDesktop = {
  lineHeightLeadText: '1.58',
  lineHeightQuote: '1.5',
  lineHeightBody1: '1.5',
  lineHeightBody2: '1.54',
  lineHeightHeadings: 'normal',
};

const textMargins = {
  textMarginBottomH1: '2.5rem',
};
const typography = {
  h1: {
    marginBottom: '2.5rem',
  },
  h2: {
    marginBottom: '1.75rem',
    textTransform: 'none',
  },
  h3: {
    marginBottom: '1rem',
  },
  h4: {
    marginBottom: '1rem',
  },
  h5: {
    marginBottom: '1rem',
  },
  h6: {
    marginBottom: '1rem',
  },
};

const pageTemplates = {
  landingPage: {
    mobile: {
      paddingTop: 0, // => value x 8px
    },
    desktop: {
      paddingTop: 0, // => value x 8px
    },
  },
  otherPageTemplates: {
    mobile: {
      paddingTop: 22, // => value x 8px
    },
    desktop: {
      paddingTop: 22, // => value x 8px
    },
  },
};

const linkColors = {
  link: brandColors.brown,
  linkHover: '#91775e',
  linkPressed: '#91775e',
};

const iconColors = {
  iconColor: brandColors.violet,
};
const hr = {
  height: '2px',
  color: '#ae9379',
  backgroundColor: '#ae9379',
};

const backgroundColors = {
  paper: '#ffff',
  grayLight: '#f0f0f0',
  grayDark: '#222221',
  beigeLight: '#fbf3e9',
  overlay: 'rgba(51,51,51,0.5)',
};

const formColors = {
  inputBorder: '#c9c9c9',
  inputBackground: '#f0f0f0',
  inputActiveBorder: brandColors.brown,
  inputBorderRadius: '0', // should be added to gammeldansk brank
};

const primaryButtonColors = {
  primaryButtonBackground: brandColors.brown,
  primaryButtonHoveredBackground: brandColors.secondaryColor,
  primaryButtonPressedBackground: brandColors.secondaryColor,
  primaryButtonDisabledBackground: '#b5afa1',
  primaryButtonContents: brandColors.beige,
};

const secondaryButtonColors = {
  secondaryButtonBackground: brandColors.brown,
  secondaryButtonHoveredBackground: brandColors.secondaryColor,
  secondaryButtonPressedBackground: brandColors.secondaryColor,
  secondaryButtonDisabledBackground: '#b5afa1',
  secondaryButtonContents: brandColors.beige,
};

const outlinedButtonColors = {
  outlinedButton: brandColors.brown,
  outlinedButtonHovered: brandColors.secondaryColor,
  outlinedButtonPressed: brandColors.secondaryColor,
  outlinedButtonDisabled: '#9a968c',
  outlinedButtonHoveredBackground: brandColors.brown,
};

const buttonSettings = {
  buttonPaddingDesktop: '16px 14px 12px 14px',
  buttonPaddingMobile: '12px 10px 8px 10px',
  borderRadius: '0',
  textTransform: 'inherit',
};

const notificationColors = {
  infoBackground: '#ecf1f8',
  successBackground: '#e6f9e8',
  warningBackground: '#fef3e8',
  errorBackground: '#fde9e9',

  infoContents: '#3d68a8',
  successContents: '#218e2c',
  warningContents: '#e8770e',
  errorContents: '#d71717',
};

const header = {
  text: linkColors.link,
  background: 'transparent',
  minHeight: '176px',
  paddingYDesktop: '60px',
  navigation: {
    activeLink: brandColors.secondaryColor,
    activeLinkBorder: 'none',
    hoverText: linkColors.linkHover,
    subMenuBackground: colors.white,
    subMenuBulletPoints: brandColors.primaryColor,
  },
  icons: {
    color: brandColors.violet,
    backgroundColor: 'transparent',
  },
};

const footer = {
  border: {
    color: 'transparent',
    width: '3px',
  },
  divider: '#ffffff',
  text: '#ffffff',
  background: brandColors.brown,
  logoBarBackground: brandColors.brown,
  padding: {
    bottom: '50px',
  },
};

const accordion = {
  backgroundColor: backgroundColors.grayLight,
  borderRadius: '0',
  color: linkColors.link,
  flexDirection: 'row',
  border: 'none',
  hover: {
    border: `none`,
    color: linkColors.linkHover,
  },
  expandIcon: {
    backgroundColor: 'inherit',
    hover: {
      backgroundColor: 'inherit',
      color: linkColors.linkHover,
    },
  },
  padding: {
    left: '24px',
    right: '12px',
  },
};

const languageSelector = {
  border: {
    color: formColors.inputBorder,
    width: '2px',
  },
  margin: '0',
};

const table = {
  border: `solid 1px ${brandColors.secondaryColor}`,
  borderRadius: '4px',
  head: {
    backgroundColor: brandColors.secondaryColor,
    color: colors.white,
  },
  row: {
    even: {
      backgroundColor: colors.white,
    },
  },
  cell: {
    border: `solid 1px ${formColors.inputBorder}`,
  },
};

const category = {
  outlined: {
    background: backgroundColors.grayLight,
    text: linkColors.link,
  },
  text: linkColors.link,
  hoverText: linkColors.linkHover,
};

const mobileNavigation = {
  text: brandColors.violet,
  icon: brandColors.violet,
  xIconBackground: primaryButtonColors.primaryButtonBackground,
  logoBarBottomBorder: 'transparent',
  navigationElementBorder: 'transparent',
  subNavigationTitleBackground: brandColors.brown,
  subNavigationTitleColor: brandColors.violet,
  drawer: {
    paper: {
      backgroundColors: brandColors.beige,
      widthDesktop: '350px',
    },
  },
};

const slider = {
  arrowBotton: {
    padding: '8px 10px 8px 10px',
  },
};

export const wineworldFinlandPrimaryTheme = {
  colors,
  breakPoints,
  brandColors,
  textColors,
  textFontFamilies,
  textFontSizesMobile,
  textFontSizesDesktop,
  textFontWeight,
  textLineHeightsMobile,
  textLineHeightsDesktop,
  textMargins,
  linkColors,
  iconColors,
  backgroundColors,
  formColors,
  primaryButtonColors,
  secondaryButtonColors,
  outlinedButtonColors,
  buttonSettings,
  notificationColors,
  header,
  footer,
  accordion,
  table,
  category,
  mobileNavigation,
  hr,
  typography,
  pageTemplates,
  languageSelector,
  slider,
};
